define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var lpAgent = require('web-agent-assets-js/lpAgent');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');

    function AgentNotificationManager(modelController) {
        var App = window.App || {};
        var chatRequestCounter = 0;
        var newChatsCounter = 0;
        var unreadChatLines = 0;
        var noID = "noID";
        var notificationTagMap = {};
        var ringingCount = 0;
        var openConversations = 0;

        lpAgent.agent.onChatsResumed(bindExternalEvents);

        function bindExternalEvents() {
            agentLEManager.onLEEvent("onEngagementNotificationManager:newline", onNewChatLine, this);
            agentLEManager.onLEEvent("onEngagementNotificationManager:acceptedChat", onNewAcceptedChat, this);
            var channel = webAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB;
            lpTag.WebAgent.channel.bind(channel.name, channel.events.ringCountChange, onNewChatRequest.bind(this));
            var appEventsChannel = webAgentStatics.COMMUNICATION_CHANNELS.AppEvents;
            lpTag.WebAgent.channel.bind(appEventsChannel.name, appEventsChannel.events.sdkNotification, onWidgetNotification.bind(this));
        }

        function onNewChatLine(data) {
            unreadChatLines = App.engagementNotificationManager.totalNumberOfWaitingChatLines();
            if (data){
                if (typeof data.count !== "undefined") {
                    setPersonaAndTabNotifications();
                }

                if (data.by && (data.text || (data.contentType === 'hosted/file' && data.fileType === 'IMG'))) {
                    var title = agentLEManager.translateLE({key: 'LEWebAgent.agentDesktopNotification.NewLineSingle', args: [{isTranslate: false, key: data.by}]});
                    var text = WebAgentUtils.removeIdnvSpansFromChatLine(data.text);

                    if (data.contentType === 'hosted/file' && data.fileType === 'IMG') {
                        text = agentLEManager.translateLE({key: 'LEWebAgent.photo_sharing_image_notification', args: [{key: text}]});
                    } else if (data.contentType === 'hosted/file' && data.fileType === 'AUDIO') {
                        text = agentLEManager.translateLE('LEWebAgent.audio_messaging_notification');
                    }

                    setDesktopNotification(title, text, 'new-chat-line.png', data.visitorId, data.chatId);
                } else if (data.visitorId) {
                    var count = window.App.engagementNotificationManager.getNotificationsForVisitor(data.visitorId);
                    if (count === 0) {
                        clearDesktopNotifications(data.visitorId);
                    }
                }
            }
        }

        function onWidgetNotification(data) {
            var visitorName = lpTag.WebAgent.agentController.getModelParam("participants.info." + data.visitorId + ".data.visitorName");
            var text = agentLEManager.translateLE({key: 'LEWebAgent.agentDesktopNotification.NewWidgetNotification', args: [{key: data.displayName}]});
            setDesktopNotification(visitorName, text, 'new-chat-line.png', data.visitorId, data.chatId);
        }

        function onNewChatRequest(data) {
            if (data && typeof data.count != "undefined") {
                var oldRingingCount = ringingCount;
                ringingCount = data.realTime || 0;
                openConversations = data.messaging || 0;
                // Here we get the current number of visitors waiting to chat. We want to trigger an event if this
                // number has changed.
                var counter = data.count - chatRequestCounter;
                // and we set the new number of visitors waiting to chat so we can compare future changes.
                chatRequestCounter = data.count;
                // If the number of visitors waiting to chat has changed - we update the change.
                if (counter !== 0) {
                    setPersonaAndTabNotifications();
                }
                // Only if we have a new request we send a desktop notification. Otherwise - there's no need
                if (counter > 0) {
                    if (ringingCount > oldRingingCount) {
                        setDesktopNotification(getTooltipLine(1, 'LEWebAgent.agentDesktopNotification.NewRequest'), getTooltipLine(ringingCount, 'LEWebAgent.agentDesktopNotification.NewRequestBody'), 'incoming-engagement.png');
                    } else {
                        setDesktopNotification(getTooltipLine(1, 'LEWebAgent.agentDesktopNotification.NewOpenConversation'), getTooltipLine(openConversations, 'LEWebAgent.agentDesktopNotification.NewOpenConversationBody'), 'incoming-engagement.png');
                    }
                }
                // If there are no waiting chats - we clear the desktop notifications for waiting chats
                if (data.count === 0) {
                    clearDesktopNotifications(noID);
                }
            }
        }

        function onNewAcceptedChat(data) {
            newChatsCounter = window.App.engagementNotificationManager.totalNewAcceptedChats();
            if (data && typeof data.count !== 'undefined') {
                setPersonaAndTabNotifications();
                if (data.count === 1) {
                    setDesktopNotification(getTooltipLine(1, 'LEWebAgent.agentDesktopNotification.AcceptedChat'), '', 'incoming-engagement.png', data.visitorId);
                } else if (data.count === -1 && data.visitorId) {
                    var count = window.App.engagementNotificationManager.getNotificationsForVisitor(data.visitorId);
                    if (count === 0) {
                        clearDesktopNotifications(data.visitorId);
                    }
                }
            }
        }

        function setDesktopNotification(title, body, icon, visitorId, chatId) {
            var iconUrl, onClick, result, notificationKey;
            if (icon) {
                iconUrl = window.leImageBaseUrl + 'src/modules/web-agent/assets/img/' + icon;
            }
            if (visitorId) {
                onClick = function () {
                    if (window.App && window.App.viewEventsHandler) {
                        var shouldFocus = true;
                        if (chatId && lpTag && lpTag.WebAgent && lpTag.WebAgent.logicController && lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatId)) {
                            if (!lpTag.WebAgent.logicController.isInMyEngagements(chatId)) {
                                // Creating the "my Engagement" section in the model creates an orb and fires a focus event
                                // so there's no need to fire another one.
                                if (lpTag.WebAgent.amsController) {
                                    // TODO: change this to use the mediator once it is available
                                    lpTag.WebAgent.amsController.createMyEngagementForConversation(chatId);
                                }
                                shouldFocus = false;
                            }
                        }
                        if (shouldFocus) {
                            window.App.viewEventsHandler.fireEvent({appName : visitorId, UIEvent : App.viewEventsHandler.eventType.VISITOR_FOCUSED});
                        }
                    }
                };
            }
            var bodyText = body && lpUtils.stripHTML(body);
            result = agentLEManager.notificationCenterNotify({DesktopNotification:{persona: 'agent', title: title, body: bodyText, iconUrl: iconUrl, onClick: onClick}});
            if (result && result.DesktopNotification && typeof result.DesktopNotification.tag !== 'undefined') {
                notificationKey = noID;
                if (visitorId) {
                    notificationKey = visitorId;
                }
                if (!notificationTagMap[notificationKey]) {
                    notificationTagMap[notificationKey] = [];
                }
                notificationTagMap[notificationKey].push(result.DesktopNotification.tag);
            }
        }

        function clearDesktopNotifications(notificationKey) {
            if (notificationKey && notificationTagMap && notificationTagMap[notificationKey] && notificationTagMap[notificationKey].length) {
                for (var index = 0; index < notificationTagMap[notificationKey].length; index++) {
                    agentLEManager.notificationCenterClearNotification({DesktopNotification: {tag: notificationTagMap[notificationKey][index]}});
                }
                delete notificationTagMap[notificationKey];
            }
        }

        function setPersonaAndTabNotifications() {
            var notificationCount = getNotificationCount();
            var tooltip = getTooltip();
            agentLEManager.triggerLEEvent("notificationCenter:notify", {persona: 'agent',
                PersonaNotification:{persona: 'agent', num: notificationCount, toolTip: tooltip},
                TabTitleNotification: {num: notificationCount, text: getTooltipLine(notificationCount, 'LEWebAgent.agentTabNotification')}});
        }

        function getNotificationCount() {
            return newChatsCounter + unreadChatLines + chatRequestCounter;
        }

        function getTooltip() {
            var tooltip = '';
            tooltip = addLineToToolTip(tooltip, newChatsCounter, 'LEWebAgent.agentNotification.AcceptedChat');
            tooltip = addLineToToolTip(tooltip, unreadChatLines, 'LEWebAgent.agentNotification.NewLine');
            tooltip = addLineToToolTip(tooltip, ringingCount, 'LEWebAgent.agentNotification.NewRequest');
            tooltip = addLineToToolTip(tooltip, openConversations, 'LEWebAgent.agentNotification.OpenConversation');
            return tooltip;
        }

        function addLineToToolTip(toolTip, parameter, newLineName) {
            var result = toolTip;
            if (parameter > 0) {
                if (result !== '') {
                    result += '<br/>';
                }
                result += getTooltipLine(parameter, newLineName);
            }
            return result;
        }

        function getTooltipLine(parameter, lineName) {
            var result = null;
            if (parameter > 1) {
                result = agentLEManager.translateLE({key: lineName + 'Multi', args: [parameter]});
            } else {
                result = agentLEManager.translateLE(lineName + 'Single');
            }
            return result;
        }
    }

    return AgentNotificationManager;

});
